<template>
  <div
    v-if="
      finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Fixture).length > 0 ||
        finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Top).length > 0 ||
        finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Side).length > 0 ||
        finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Bottom).length > 0
    "
  >
    <label>{{ $t('common.finish') }}</label>
    <div style="clear:both">
      <div
        v-if="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Fixture).length > 0"
        style="padding-top:5px;padding-bottom:35px;"
      >
        <div style="width:45%;padding-right:20px;float:left">
          <Select
            v-model="order.fixtureFinishID"
            :required="false"
            :options="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Fixture)"
            value-field="finishID"
            label-field="description"
            :placeholder="$t('orderLine.fixtureFinish')"
            @input="fixtureSelected"
          ></Select>
        </div>
        <div
          v-if="finishTypeNeedsMeasurement(order.fixtureFinishID, 'fixtureFinishMeasurementInCm')"
          style="width:20%;float:left"
        >
          <el-input-number
            v-model="order.fixtureFinishMeasurementInCm"
            style="width:75%"
            :placeholder="$t('orderLine.headingHeight')"
            :required="false"
            :maxlength="6"
            :precision="1"
            :controls="false"
            @input="emitValues"
          />
          cm
        </div>
      </div>
      <div
        v-if="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Top).length > 0"
        style="padding-top:5px;padding-bottom:35px"
      >
        <div style="width:45%;padding-right:20px;float:left">
          <Select
            v-model="order.topFinishID"
            :required="false"
            :options="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Top)"
            value-field="finishID"
            label-field="description"
            :placeholder="$t('orderLine.topFinish')"
            @input="emitValues"
          ></Select>
        </div>
        <div
          v-if="finishTypeNeedsProduct(order.topFinishID, 'topFinishProductID')"
          style="width:30%;padding-right:20px;float:left"
        >
          <Select
            v-model="order.topFinishProductID"
            :placeholder="$t('orderLine.product')"
            :options="products.filter(p => p.productTypeID === requiredProductTypeIDs['topFinishProductID'])"
            value-field="productID"
            label-field="description"
            :required="false"
            @input="emitValues"
          />
        </div>
        <div
          v-if="finishTypeNeedsMeasurement(order.topFinishID, 'topFinishMeasurementInCm')"
          style="width:20%;float:left"
        >
          <el-input-number
            v-model="order.topFinishMeasurementInCm"
            style="width:50%"
            :placeholder="$t('orderLine.measurement')"
            :required="false"
            :maxlength="6"
            :precision="1"
            :controls="false"
            @input="emitValues"
          />
          cm
        </div>
      </div>
      <div
        v-if="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Side).length > 0"
        style="padding-top:5px;padding-bottom:35px;"
      >
        <div style="width:45%;padding-right:20px;float:left">
          <Select
            v-model="order.sideFinishID"
            :required="false"
            :options="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Side)"
            value-field="finishID"
            label-field="description"
            :placeholder="$t('orderLine.sideFinish')"
            @input="emitValues"
          />
        </div>
        <div
          v-if="finishTypeNeedsProduct(order.sideFinishID, 'sideFinishProductID')"
          style="width:30%;padding-right:20px;float:left"
        >
          <Select
            v-model="order.sideFinishProductID"
            :placeholder="$t('orderLine.product')"
            :options="products.filter(p => p.productTypeID === requiredProductTypeIDs['sideFinishProductID'])"
            value-field="productID"
            label-field="description"
            :required="false"
            @input="emitValues"
          />
        </div>
        <div
          v-if="finishTypeNeedsMeasurement(order.sideFinishID, 'sideFinishMeasurementInCm')"
          style="width:20%;float:left"
        >
          <el-input-number
            v-model="order.sideFinishMeasurementInCm"
            style="width:50%"
            :placeholder="$t('orderLine.measurement')"
            :required="false"
            :maxlength="6"
            :precision="1"
            :controls="false"
            @input="emitValues"
          />
          cm
        </div>
      </div>
      <div
        v-if="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Bottom).length > 0"
        style="padding-top:5px;padding-bottom:35px;"
      >
        <div style="width:45%;padding-right:20px;float:left">
          <Select
            v-model="order.bottomFinishID"
            :required="false"
            :options="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Bottom)"
            value-field="finishID"
            label-field="description"
            :placeholder="$t('orderLine.bottomFinish')"
            @input="emitValues"
          />
        </div>
        <div
          v-if="finishTypeNeedsProduct(order.bottomFinishID, 'bottomFinishProductID')"
          style="width:30%;padding-right:20px;float:left"
        >
          <Select
            v-model="order.bottomFinishProductID"
            :placeholder="$t('orderLine.product')"
            :options="products.filter(p => p.productTypeID === requiredProductTypeIDs['bottomFinishProductID'])"
            value-field="productID"
            label-field="description"
            :required="false"
            @input="emitValues"
          />
        </div>
        <div
          v-if="finishTypeNeedsMeasurement(order.bottomFinishID, 'bottomFinishMeasurementInCm')"
          style="width:20%;float:left"
        >
          <el-input-number
            v-model="order.bottomFinishMeasurementInCm"
            style="width:50%"
            type="number"
            :placeholder="$t('orderLine.measurement')"
            :required="false"
            :maxlength="6"
            :precision="1"
            :controls="false"
            @input="emitValues"
          />
          cm
        </div>
      </div>
      <div
        v-if="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Extra).length > 0"
        style="padding-top:5px"
      >
        <extras-table
          :extra-finishes-available="finishesAvailable.filter(f => f.finishTypeOption === finishTypeOption.Extra)"
          @input="assignExtras"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { FinishTypeOption } from '@/utils/constants';
import Select from '@/components/DSE/Select';
import ExtrasTable from './ExtrasTable';

export default {
  name: 'GenericFinishComponents',
  components: { Select, ExtrasTable },
  props: {
    order: {
      type: Object
    },
    finishesAvailable: {
      type: Array
    }
  },
  data() {
    return {
      finishTypeOption: FinishTypeOption,
      requiredProductTypeIDs: {}
    };
  },
  computed: {
    finishTypes() {
      return this.$store.getters['finishType/loadedItems'];
    },
    products() {
      return this.$store.getters['product/loadedItems'];
    }
  },
  watch: {},
  created() {},
  methods: {
    fixtureSelected() {
      if (!this.order.fixtureFinishMeasurementInCm) {
        this.order.fixtureFinishMeasurementInCm = undefined;
      }
      this.emitValues();
    },
    finishTypeNeedsMeasurement(finishID, measurementField) {
      let needsMeasurement = false;
      let finishType;
      if (finishID) {
        const finishTypeID = this.finishesAvailable.find(f => f.finishID === finishID).finishTypeID;
        finishType = this.finishTypes.find(ft => ft.id === finishTypeID);
        if (!finishType.measurementRequiredYN) {
          this.order[measurementField] = null;
        }
        needsMeasurement = !!finishType.measurementRequiredYN;
      }
      if (!finishType || !finishType.measurementRequiredYN) {
        this.order[measurementField] = null;
      }
      return needsMeasurement;
    },
    finishTypeNeedsProduct(finishID, productField) {
      let needsProduct = false;
      let finishType;
      if (finishID) {
        const finishTypeID = this.finishesAvailable.find(f => f.finishID === finishID).finishTypeID;
        const finishType = this.finishTypes.find(ft => ft.id === finishTypeID);
        this.requiredProductTypeIDs[productField] = finishType.requiredProductTypeID;
        needsProduct = finishType.requiredProductTypeID;
      }
      if (!finishType || !finishType.requiredProductTypeID) {
        this.order[productField] = null;
      }
      return needsProduct;
    },
    assignExtras(extras) {
      this.order.extras = extras;
      this.emitValues();
    },
    emitValues() {
      this.$emit('input', this.order);
    }
  }
};
</script>
<style lang="scss"></style>
